import {
  type PairingV1 as Pairing,
  setPairingRating,
  LikeDislike,
  type LikeDislikeRatings,
} from '@hungryroot/rest';
export { LikeDislike as ApiV1LikeDislikeEnum, type LikeDislikeRatings };

export const LikeDislikeTags = {
  NoRating: 0,
  Liked: 1,
  Disliked: -1,
} as const;

export type LikeDislikeTagsRatings =
  (typeof LikeDislikeTags)[keyof typeof LikeDislikeTags];

export type UserDefinedRating = Exclude<LikeDislikeRatings, undefined>;

export function getLikeDislikeRatingFromPairing(
  pairing: Pick<Pairing, 'liked'>
) {
  switch (pairing?.liked) {
    case undefined:
    case null:
      return LikeDislike.NoRating;
    case false:
      return LikeDislike.Disliked;
    case true:
      return LikeDislike.Liked;
  }
}

export { setPairingRating };
